<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.purchase_entry">
    <div *ngIf="businessId != '' && businessId != '0'">
        <div *ngIf="isBatchEnabledInBusiness == false" style="text-align: center;font-size: larger;margin-top: 10px;">
            {{localService.languageContent.common.setting_not_enabled_in_business}}
            <br />
            <button type="button" class="btn btn-primary" style="margin-top: 25px;"
                (click)="onAction(2)">{{localService.languageContent.common.click_here_to_visit_business}}</button>
        </div>
        <app-activate-service *ngIf="!hasValidBatchDetails && isBatchEnabledInBusiness" [businessId]="businessId"
            [additionalServiceType]="AdditionalServiceType.BatchDetails" (onActivated)="onLoad()" [ctryCode]="ctryCode"
            [userId]="userId" />
        <div class="banner center" style="max-width:1200px;" *ngIf="hasValidBatchDetails">
            <div class="row row_header freeze_height" style="border: none;">
                <div class="col-2" style="text-align: left;">
                    <button class="button_icon button_icon_color" (click)="onAction(1)">
                        note_add
                    </button>
                </div>
                <div class="col-10" style="text-align: right;">
                    <label style="font-weight: normal; margin-left: 30px;">
                        <input type="checkbox" [(ngModel)]="isShowInActive" (change)="onLoad()" />
                        <span class="normal_color">{{localService.languageContent.purchase_entry.show_inactive}}</span>
                    </label>
                </div>
            </div>
            <div class="row row_header freeze_height">
                <div class="col-1">
                    {{localService.languageContent.table.action}}
                </div>
                <div class="col-4">
                    {{localService.languageContent.purchase_entry.batch_id}}
                </div>
                <div class="col-3">
                    {{localService.languageContent.purchase_entry.expire_on}}
                </div>
                <div class="col-3">
                    {{localService.languageContent.table.created_on}}
                </div>
            </div>
            <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
                <div *ngIf="(source && source.items.length > 0)" class="item-found">
                    <div class="row styled_row" *ngFor="let item of source.items">
                        <div class="col-md-1">
                            <a class="button"
                                [routerLink]="['/batch-entry-details' + localService.basicParamsString,businessId,item.key]">
                                <i class="material-icons button icon_adjust">account_tree</i>
                            </a>
                            <button class="button_icon button_icon_color icon_adjust" (click)="onAction(1,item.key)">
                                edit
                            </button>
                        </div>
                        <div class="col-md-4">
                            <button class="button_icon icon_adjust"
                                title="{{item.v4 == '1' ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                                (click)="onActiveInactiveStatus(item.key)"
                                [ngStyle]="{'color': item.v4 == '1' ? 'yellowgreen' : 'orangered' }">{{item.v4 == '1' ?
                                "toggle_on" : "toggle_off"}}</button>
                            <span class="en">
                                {{item.v2}}
                            </span>
                        </div>
                        <div class="col-md-3">
                            <span class="en" *ngIf="item.v5 == '1'">
                                {{localService.languageContent.purchase_entry.no_expiry}}
                            </span>
                            <span class="en" *ngIf="item.v5 == '0'">
                                {{item.v3 | date : 'dd-MMM-yyyy'}}
                            </span>
                        </div>
                        <div class="col-md-3">
                            <span class="en">
                                {{item.v8 | localDate}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-paging *ngIf="source && source.paging && hasValidBatchDetails" [paging]="source.paging"
            (onPagingRefreshed)="onLoad()"></app-paging>
    </div>
</div>
<div>
    <app-batch-entry [(isOpenPopup)]="isOpenBatchEntry" [businessId]="businessId" [id]="selectedBatchEntryId"
        (onClose)="onLoad()" />
</div>